<template>
  <div class="selection-client">
    <ul class="nav nav-tabs nav-tabs-client">
      <li :class="{active: onglet === 'membre'}">
        <a href="#" @click.prevent="onglet = 'membre'"><i class="fa fa-user"></i> Membre</a>
      </li>
      <li :class="{active: onglet === 'club'}">
        <a href="#" @click.prevent="onglet = 'club'"><i class="fa fa-home"></i> Club</a>
      </li>
      <li :class="{active: onglet === 'libre'}">
        <a href="#" @click.prevent="onglet = 'libre'"><i class="fa fa-pencil"></i> Saisie libre</a>
      </li>
      <li v-if="carnet.length" :class="{active: onglet === 'carnet'}">
        <a href="#" @click.prevent="onglet = 'carnet'">
          <i class="fa fa-book"></i> Carnet <span class="badge">{{ carnet.length }}</span>
        </a>
      </li>
    </ul>

    <div class="tab-content">
      <!-- Membre ABFT -->
      <div v-show="onglet === 'membre'" class="form-group">
        <label>Rechercher un membre</label>
        <v-select v-model="membreSelectionne"
                  label="fullName"
                  placeholder="Nom ou n° de licence..."
                  :debounce="250"
                  :filterable="false"
                  :on-search="chercherMembres"
                  :options="membres">
          <span slot="selected-option" slot-scope="props">{{ props.selectedOption.fullName }}</span>
          <template slot="option" slot-scope="props">
            <span :class="props.item.licencie ? 'text-green' : 'text-red'">
              {{ props.item.fullName }}
            </span>
            <small class="text-muted">
              — n°{{ props.item.numLicence }}
              <span v-if="props.item.cp || props.item.ville">· {{ props.item.cp }} {{ props.item.ville }}</span>
            </small>
          </template>
        </v-select>
      </div>

      <!-- Club ABFT -->
      <div v-show="onglet === 'club'" class="form-group">
        <label>Rechercher un club</label>
        <v-select v-model="clubSelectionne"
                  label="club"
                  placeholder="Nom ou n° de club..."
                  :debounce="250"
                  :filterable="false"
                  :on-search="chercherClubs"
                  :options="clubs">
          <span slot="selected-option" slot-scope="props">{{ props.selectedOption.club }}</span>
          <template slot="option" slot-scope="props">
            {{ props.item.club }}
            <small class="text-muted"> — n°{{ props.item.numero_club }}</small>
          </template>
        </v-select>
        <p v-if="chargementClub" class="help-block">
          <i class="fa fa-refresh fa-spin"></i> Récupération de l'adresse du club...
        </p>
      </div>

      <!-- Carnet local -->
      <div v-show="onglet === 'carnet'">
        <ul class="list-unstyled liste-carnet">
          <li v-for="(entree, index) in carnet" :key="index">
            <a href="#" @click.prevent="$emit('client-choisi', construireDepuisCarnet(entree))">
              <strong>{{ entree.nom }}</strong>
              <small class="text-muted"> {{ entree.cp }} {{ entree.ville }}</small>
            </a>
            <button type="button" class="btn btn-link btn-xs pull-right text-danger"
                    title="Retirer du carnet"
                    @click="$emit('oublier', index)">
              <i class="fa fa-times"></i>
            </button>
          </li>
        </ul>
      </div>
    </div>

    <!-- Champs du destinataire : toujours visibles et modifiables, quelle que soit la source -->
    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <label>Nom / dénomination</label>
          <input type="text" class="form-control" :value="client.nom"
                 placeholder="Nom du client"
                 @input="modifier('nom', $event.target.value)">
        </div>
      </div>
      <div class="col-xs-12">
        <div class="form-group">
          <label>Adresse</label>
          <input type="text" class="form-control" :value="client.adresse"
                 placeholder="Rue et numéro"
                 @input="modifier('adresse', $event.target.value)">
        </div>
      </div>
      <div class="col-xs-4">
        <div class="form-group">
          <label>Code postal</label>
          <input type="text" class="form-control" :value="client.cp"
                 @input="modifier('cp', $event.target.value)">
        </div>
      </div>
      <div class="col-xs-8">
        <div class="form-group">
          <label>Ville</label>
          <input type="text" class="form-control" :value="client.ville"
                 @input="modifier('ville', $event.target.value)">
        </div>
      </div>
      <div class="col-xs-6">
        <div class="form-group">
          <label>E-mail</label>
          <input type="text" class="form-control" :value="client.email"
                 @input="modifier('email', $event.target.value)">
        </div>
      </div>
      <div class="col-xs-6">
        <div class="form-group">
          <label>N° d'entreprise</label>
          <input type="text" class="form-control" :value="client.numEntreprise"
                 @input="modifier('numEntreprise', $event.target.value)">
        </div>
      </div>
    </div>

    <button type="button" class="btn btn-default btn-sm"
            :disabled="!client.nom"
            @click="$emit('memoriser')">
      <i class="fa fa-bookmark-o"></i> Mémoriser ce client
    </button>
  </div>
</template>

<script type="text/babel">
  import {mapGetters} from 'vuex'
  import vSelect from '../../Communs/vSelect'

  export default {
    name: 'SelectionClient',
    components: {vSelect},
    props: {
      client: {type: Object, required: true},
      carnet: {type: Array, default: function () { return [] }}
    },
    data () {
      return {
        onglet: 'membre',
        membres: [],
        clubs: [],
        membreSelectionne: null,
        clubSelectionne: null,
        chargementClub: false,
        requetePrecedente: false
      }
    },
    computed: {
      ...mapGetters({
        getRoute: 'getRoute'
      })
    },
    watch: {
      membreSelectionne (membre) {
        if (!membre) return
        this.$emit('client-choisi', {
          source: 'membre',
          idSource: membre.id,
          nom: membre.fullName,
          adresse: membre.adresse || '',
          cp: membre.cp || '',
          ville: membre.ville || '',
          pays: 'Belgique',
          email: '',
          numEntreprise: ''
        })
      },
      clubSelectionne (club) {
        if (!club) return
        this.completerDepuisClub(club)
      }
    },
    methods: {
      modifier (champ, valeur) {
        this.$emit('modifier', {champ: champ, valeur: valeur})
      },
      /**
       * L'API cherche aussi par numéro de licence et par numéro de club, en
       * égalité exacte : un numéro à deux chiffres doit donc déclencher la
       * recherche, là où un début de nom aussi court ne ramènerait que du bruit.
       */
      rechercheExploitable (recherche, longueurMinimale) {
        const terme = String(recherche || '').trim()
        if (!terme) return false
        if (/^\d+$/.test(terme)) return terme.length >= 1
        return terme.length >= longueurMinimale
      },
      construireDepuisCarnet (entree) {
        return {
          source: 'carnet',
          idSource: null,
          nom: entree.nom || '',
          adresse: entree.adresse || '',
          cp: entree.cp || '',
          ville: entree.ville || '',
          pays: entree.pays || 'Belgique',
          email: entree.email || '',
          numEntreprise: entree.numEntreprise || ''
        }
      },
      chercherMembres (recherche, chargement) {
        if (!this.rechercheExploitable(recherche, 3)) return
        const composant = this
        chargement(true)
        this.$http.post(this.getRoute('memberSearch'), {q: recherche}, {
          before (requete) {
            if (composant.requetePrecedente) composant.requetePrecedente.abort()
            composant.requetePrecedente = requete
          }
        }).then(function (reponse) {
          composant.membres = Array.isArray(reponse.data) ? reponse.data : []
          chargement(false)
        }, function () {
          chargement(false)
          composant.membres = []
          composant.$noty.error('La recherche de membres a échoué')
        })
      },
      /**
       * clubSearch est une route GET côté API : les critères passent en query
       * string, pas en corps de requête.
       */
      chercherClubs (recherche, chargement) {
        if (!this.rechercheExploitable(recherche, 2)) return
        const composant = this
        chargement(true)
        this.$http.get(this.getRoute('clubSearch'), {params: {q: recherche}})
          .then(function (reponse) {
            composant.clubs = Array.isArray(reponse.data) ? reponse.data : []
            chargement(false)
          }, function () {
            chargement(false)
            composant.clubs = []
            composant.$noty.error('La recherche de clubs a échoué')
          })
      },
      /**
       * La recherche de club ne renvoie pas l'adresse : il faut un second appel
       * sur la fiche complète du club pour la récupérer.
       */
      completerDepuisClub (club) {
        const composant = this
        this.chargementClub = true
        this.$emit('client-choisi', {
          source: 'club',
          idSource: club.id,
          nom: club.club,
          adresse: '',
          cp: '',
          ville: '',
          pays: 'Belgique',
          email: '',
          numEntreprise: ''
        })
        this.$http.get(this.getRoute('getInfosClub') + club.id).then(function (reponse) {
          const fiche = reponse.data || {}
          composant.chargementClub = false
          composant.$emit('client-choisi', {
            source: 'club',
            idSource: club.id,
            nom: fiche.club || club.club,
            adresse: fiche.adresse || '',
            cp: fiche.cp || '',
            ville: fiche.ville || '',
            pays: 'Belgique',
            email: fiche.mail || '',
            numEntreprise: fiche.bce || ''
          })
        }, function () {
          composant.chargementClub = false
          composant.$noty.error('Adresse du club introuvable, complétez-la à la main')
        })
      }
    }
  }
</script>

<style scoped>
  .nav-tabs-client {
    margin-bottom: 14px;
  }

  .nav-tabs-client > li > a {
    padding: 6px 10px;
    font-size: 12px;
  }

  .liste-carnet {
    max-height: 190px;
    overflow-y: auto;
    margin-bottom: 14px;
  }

  .liste-carnet > li {
    padding: 4px 0;
    border-bottom: 1px solid #f4f4f4;
  }
</style>



// WEBPACK FOOTER //
// src/components/Outils/Facture/SelectionClient.vue